import React, { useEffect, useState } from "react"

import "./Diagnosis.css"

import BtnSave from "../../Components/Commons/Buttons/BtnSave"
import TextArea from "../Commons/Forms/TextArea"
// import DateTimeField from "../Commons/Forms/DateTimeField"

import { toast } from "react-toastify"
import { Radio, Select } from "antd"
import { Col, Row } from "react-bootstrap"
import { Checkbox, DatePicker, Input, Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import {
  createDiagnostic,
  getLabTestForEMRDiagnostics,
  updateDiagnostic,
  getLabtestEmr,
  getLabCategories,
} from "../Helpers/API/Diagnostics/DiagnosticsApi"
import { fastingOptions } from "../../Constants/fastingOptions"
import dayjs from "dayjs"
import TextField from "../Commons/Forms/TextField"
import {
  getRole,
  // getUser,
} from "../Helpers/Utilities/Common"

const customSpinner = (
  <LoadingOutlined style={{ fontSize: 40, color: "#2d6e5e" }} spin />
)

function Diagnostics({
  assessmentType,
  patientId,
  patientDetails,
  assessmentId,
  addCheckUpData,
  showAdmit,
  showOutPatient,
  addDiagnostic,
  setAddDiagnostic,
  selectedDiagnosticTests,
  setSelectedDiagnosticTests,
  fetchAssessmentHistory,
  doctorOptions,
  setSelectedCheckUpTab,
}) {
  const role = getRole()
  // const userId = getUser()
  const [isClicked, setIsClicked] = useState(false)
  const [diagnosticTests, setDiagnosticTests] = useState(null)
  const [checkedDiagnostics, setCheckedDiagnostics] = useState([])
  const [loading, setLoading] = useState(false) // State for loader
  const [initialDiagnosticData, setInitialDiagnosticData] = useState([])
  const [action, setAction] = useState("")
  const [labCategories, setLabCategories] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    parent_category_id: "",
    term: "",
  })

  //Function for filter by lab type
  function handleLabFilter(value) {
    setFilterConfig((prev) => ({
      ...prev,
      parent_category_id: value,
    }))
  }

  //Function for search lab test name
  function handleSearch(e) {
    setFilterConfig((prev) => ({
      ...prev,
      term: e,
    }))
  }

  const handleEmptySearch = (e) => {
    if (e.target.value === "") {
      setFilterConfig((prev) => ({
        ...prev,
        term: e.target.value || "",
      }))
    }
  }

  // Funtion for handling the values of input fields
  function handleAddChange(e, field) {
    var { name, value, type, checked } = e.target
    if (type === "radio") {
      if (field === "fasting") {
        name = "fasting"
      }
      if (field === "is_philhealth_member") {
        name = "is_philhealth_member"
      }
    } else if (type === "checkbox") {
      if (field === "for_lab") {
        setAddDiagnostic((prev) => {
          return { ...prev, for_lab: checked ? "1" : "0" }
        })
      }
    }
    setAddDiagnostic((prev) => {
      return { ...prev, [name]: value }
    })
  }

  // Function for handling date for all diagnostics
  function handleDateChange(dateTime) {
    var formattedDateTime = dateTime ? dateTime.format("YYYY-MM-DD") : null
    setAddDiagnostic((prev) => ({
      ...prev,
      diagnostic_date: formattedDateTime,
    }))
  }

  // Function for handling selected doctor
  function handleDoctorChange(value) {
    setAddDiagnostic((prev) => ({
      ...prev,
      doctor_id: value,
    }))
  }

  // Function for what diagnostics is checked
  const handleSelect = (e, isDate, type, subtype, action) => {
    const { name, value, checked } = e.target
    const newCheckedValues = [...checkedDiagnostics]

    if (action === "edit") {
      if (newCheckedValues.includes(value)) {
        newCheckedValues.splice(newCheckedValues.indexOf(value), 1)
      } else {
        newCheckedValues.push(value)
      }

      setCheckedDiagnostics(newCheckedValues)

      if (isDate) {
        setSelectedDiagnosticTests((prev) => ({
          ...prev,
          [name]: value + ":00", // key: lab_name, value: lab_schedule
          [`${name}_id`]: prev[`${name}_id`] || null, // diagnostic item id
        }))
        return
      }
      if (checked) {
        setSelectedDiagnosticTests((prev) => {
          const updated = { ...prev }
          // Set all other existing is_new values to "0" if is_existing is "1"
          Object.keys(updated).forEach((key) => {
            if (key.endsWith("_is_new")) {
              const testKey = key.replace("_is_new", "")
              const isExistingKey = `${testKey}_is_existing`
              if (updated[isExistingKey] === "1") {
                updated[key] = "0"
              }
            }
          })
          // Add new test data
          updated[value] = null // key: lab_name, value: lab_schedule
          updated[`${value}_id`] = prev[`${value}_id`] || null
          updated[`${value}_type`] = type // Add the type
          updated[`${value}_subtype`] = subtype // Add the subtype
          updated[`${value}_is_new`] = "1"
          updated[`${value}_is_existing`] = "0"
          return updated
        })
      } else {
        // Unchecking logic — decide based on changes
        const _selectedDiagnosticTests = hasTestChanges()
          ? { ...selectedDiagnosticTests }
          : { ...initialDiagnosticData?.selectedDiagnosticTests }

        delete _selectedDiagnosticTests[value]
        delete _selectedDiagnosticTests[`${value}_id`]
        delete _selectedDiagnosticTests[`${value}_type`]
        delete _selectedDiagnosticTests[`${value}_subtype`]
        delete _selectedDiagnosticTests[`${value}_is_new`]
        delete _selectedDiagnosticTests[`${value}_is_existing`]
        setSelectedDiagnosticTests(_selectedDiagnosticTests)
      }
    } else if (action === "add") {
      if (newCheckedValues.includes(value)) {
        const index = newCheckedValues.indexOf(value)
        newCheckedValues.splice(index, 1)
      } else {
        newCheckedValues.push(value)
      }
      setCheckedDiagnostics(newCheckedValues)
      if (isDate) {
        setSelectedDiagnosticTests((prev) => {
          return {
            ...prev,
            [name]: value + ":00", // key: lab_name, value: lab_schedule
            [`${name}_id`]: prev[`${name}_id`] || null, // diagnostic item id
          }
        })
      } else {
        if (checked) {
          setSelectedDiagnosticTests((prev) => {
            return {
              ...prev,
              [value]: null, // key: lab_name, value: lab_schedule
              [`${value}_id`]: prev[`${value}_id`] || null, // diagnostic item id
              [`${value}_type`]: type, // Add the type
              [`${value}_subtype`]: subtype, // Add the subtype
              [`${value}_is_new`]: "1",
              [`${value}_is_existing`]: "0",
            }
          })
        } else {
          var _selectedDiagnosticTests = { ...selectedDiagnosticTests }
          delete _selectedDiagnosticTests[value]
          delete _selectedDiagnosticTests[`${value}_id`]
          delete _selectedDiagnosticTests[`${value}_type`]
          delete _selectedDiagnosticTests[`${value}_subtype`]
          delete _selectedDiagnosticTests[`${value}_is_new`]
          delete _selectedDiagnosticTests[`${value}_is_existing`]
          setSelectedDiagnosticTests(() => _selectedDiagnosticTests)
        }
      }
    }
  }

  // Function for edit diagnostic
  const handleEdit = async () => {
    var labNames = []
    var labSchedules = []
    var labTypes = []
    var diagnosticItemIds = []
    var diagnosticItemSubTypes = []
    var diagnosticItemIsNew = []
    var diagnosticItemIsExisting = []
    var _parsedLabSchedules = []

    Object.entries(selectedDiagnosticTests).forEach(([key, value]) => {
      if (key.includes("_id")) {
        diagnosticItemIds.push(value || "")
      } else if (key.includes("_type")) {
        labTypes.push(value)
      } else if (key.includes("_subtype")) {
        diagnosticItemSubTypes.push(value)
      } else if (key.includes("_is_new")) {
        diagnosticItemIsNew.push(value)
      } else if (key.includes("_is_existing")) {
        diagnosticItemIsExisting.push(value)
      } else {
        labNames.push(key)
        labSchedules.push(value)
      }
    })

    // Remove the "T" in dates
    labSchedules.forEach((sched) => {
      _parsedLabSchedules.push(sched ? sched.replace("T", " ") : null)
    })

    setIsClicked(true)
    const res = await updateDiagnostic({
      ...addDiagnostic,
      lab_name: labNames,
      lab_schedule: _parsedLabSchedules,
      case_number: addDiagnostic.case_number,
      diagnostic_date: addDiagnostic.diagnostic_date,
      room_number: addDiagnostic.room_number,
      for_lab: addDiagnostic.for_lab,
      is_philhealth_member: addDiagnostic.is_philhealth_member,
      chief_complaint: addDiagnostic.chief_complaint,
      doctor_id: addDiagnostic.doctor_id,
      diagnostic_item_id: diagnosticItemIds,
      sub_type: diagnosticItemSubTypes,
      is_new: diagnosticItemIsNew,
      type: labTypes,
    })

    if (res.data) {
      toast.success(res.data.message)
      // fetchAssessmentHistory() // fetch the updated assessment data
      setSelectedDiagnosticTests({}) // reset form

      if (assessmentType === "for_admission" || assessmentType === "admit") {
        showAdmit(true) // go to Admission Form
      } else if (assessmentType === "outpatient") {
        showOutPatient(true)
      }
       if (
        assessmentType === "for_admission" ||
        assessmentType === "admit" ||
        assessmentType === "outpatient"
      ) {
        setSelectedCheckUpTab("therapeutics");
      }
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((err) => {
        toast.error(err)
      })
    }
    setIsClicked(false)
  }

  console.log(selectedDiagnosticTests)

  // Function for create diagnostics
  const handleSubmit = async () => {
    var labNames = []
    var labSchedules = []
    var labTypes = []
    var diagnosticItemIds = []
    var diagnosticItemSubTypes = []
    var diagnosticItemIsNew = []
    var diagnosticItemIsExisting = []
    var _parsedLabSchedules = []

    Object.entries(selectedDiagnosticTests).forEach(([key, value]) => {
      if (key.includes("_id")) {
        diagnosticItemIds.push(value)
      } else if (key.includes("_type")) {
        labTypes.push(value)
      } else if (key.includes("_subtype")) {
        diagnosticItemSubTypes.push(value)
      } else if (key.includes("_is_new")) {
        diagnosticItemIsNew.push(value)
      } else if (key.includes("_is_existing")) {
        diagnosticItemIsExisting.push(value)
      } else {
        labNames.push(key)
        labSchedules.push(value)
      }
    })

    // Remove the "T" in dates
    labSchedules.forEach((sched) => {
      _parsedLabSchedules.push(sched ? sched.replace("T", " ") : null)
    })
    setIsClicked(true)
    const res = await createDiagnostic({
      ...addDiagnostic,
      patient_id: addDiagnostic.patient_id || patientId,
      assessment_id: addDiagnostic.assessment_id || assessmentId,
      case_number: addDiagnostic.case_number,
      diagnostic_date: addDiagnostic.diagnostic_date,
      room_number: addDiagnostic.room_number,
      for_lab: addDiagnostic.for_lab,
      is_philhealth_member: addDiagnostic.is_philhealth_member,
      chief_complaint: addDiagnostic.chief_complaint,
      doctor_id: addDiagnostic.doctor_id,
      lab_name: labNames,
      lab_schedule: _parsedLabSchedules,
      diagnostic_item_id: Array(labNames.length).fill(null),
      sub_type: diagnosticItemSubTypes,
      is_new: diagnosticItemIsNew,
      type: labTypes,
    })

    if (res.data) {
      toast.success(res.data.message)
      // fetchAssessmentHistory() // fetch the updated assessment data
      setSelectedDiagnosticTests({}) // reset form

      if (assessmentType === "for_admission" || assessmentType === "admit") {
        showAdmit(true) // go to Admission Form
      } else if (assessmentType === "outpatient") {
        showOutPatient(true)
      }
     if (
        assessmentType === "for_admission" ||
        assessmentType === "admit" ||
        assessmentType === "outpatient"
      ) {
        setSelectedCheckUpTab("therapeutics");
      }
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((err) => {
        toast.error(err)
      })
    }
    setIsClicked(false)
  }

  // Function get lab test of diagnostics
  async function fetchLabTestForDiagnostics() {
    setLoading(true)
    const hasCategory = !!filterConfig.parent_category_id
    const hasSearch = !!(filterConfig.term && filterConfig.term.trim())
    if (!hasCategory && !hasSearch) {
      setDiagnosticTests(null)
      setLoading(false)
      return
    }
    const res = await getLabtestEmr(filterConfig)
    if (res.data) {
      setDiagnosticTests(res.data)
    } else if (res.error) {
      setDiagnosticTests(null)
    }
    setLoading(false)
  }

   async function fetchLabCategories() {
    setLoading(true);
    const res = await getLabCategories();

    if (res.data) {
      const result = res.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      // Add "Others" option
      result.push({
        id: "others",
        value: "others",
        label: "OTHERS",
      });
      setLabCategories(result);
    } else if (res.error) {
      setLabCategories([
        {
          id: "others",
          value: "others",
          label: "OTHERS",
        },
      ]);
    }
    setLoading(false);
  }


  //function for checking if whole diagnostics has changes
  function hasChanges() {
    if (!initialDiagnosticData) return false

    // Check if any diagnostic form fields have changed
    const formFieldsChanged = Object.keys(addDiagnostic).some((key) => {
      return addDiagnostic[key] !== initialDiagnosticData[key]
    })

    // Check if any tests have been added/removed
    const testsChanged =
      JSON.stringify(selectedDiagnosticTests) !==
      JSON.stringify(initialDiagnosticData.selectedTests)

    return formFieldsChanged || testsChanged
  }

  //function for checking if diagnostics tests has changes
  function hasTestChanges() {
    if (!initialDiagnosticData) return false

    // Check if any tests have been added/removed
    const testsChanged =
      JSON.stringify(selectedDiagnosticTests) !==
      JSON.stringify(initialDiagnosticData.selectedTests)

    return testsChanged
  }

  function checkAction() {
    if (
      selectedDiagnosticTests &&
      Object.keys(selectedDiagnosticTests).length > 0
    ) {
      setAction("edit")
    } else {
      setAction("add")
    }
  }

  useEffect(() => {
    fetchLabTestForDiagnostics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig])

   useEffect(() => {
    fetchLabCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkAction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addDiagnostic, selectedDiagnosticTests])

  useEffect(() => {
    // Set initial diagnostic data when component mounts or addCheckUpData changes
    setInitialDiagnosticData({
      ...addDiagnostic,
      selectedTests: { ...selectedDiagnosticTests },
    })

    //if patient is a sunday patient, make the last checkup date as the diagnostic date
    if (addCheckUpData.is_sunday_patient === "1") {
      setAddDiagnostic((prev) => ({
        ...prev,
        diagnostic_date: addCheckUpData.last_checkup_date,
      }))
    } else {
      setAddDiagnostic((prev) => ({
        ...prev,
        diagnostic_date: dayjs(addCheckUpData.added_on).format("YYYY-MM-DD"),
      }))
    }

    setAddDiagnostic((prev) => ({
      ...prev,
      doctor_id: addCheckUpData.doctor_id, //set doctor_id from add checkup data
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCheckUpData])

  return (
    <div className="">
      <div className="pt-4">
        <Row className="mt-2 px-1">
          <Col xs={3}>
            <label>Case Number</label>
            <TextField
              id="case_number"
              name="case_number"
              size={`sm`}
              value={addDiagnostic.case_number}
              onChange={handleAddChange}
            />
          </Col>
          <Col xs={3}>
            <label>
              Diagnostic Date
              <label className="red"> *</label>
            </label>
            <DatePicker
              id="diagnostic_date"
              name="diagnostic_date"
              className="w-100"
              format="YYYY-MM-DD"
              placeholder=""
              value={
                addDiagnostic?.diagnostic_date
                  ? dayjs(addDiagnostic.diagnostic_date)
                  : null
              }
              onChange={(date) => handleDateChange(date)}
              disabled={addCheckUpData.is_sunday_patient === "1"}
              allowClear
              required
            />
          </Col>
          <Col xs={3}>
            <TextField
              id="room_number"
              name="room_number"
              formLabel={`Room Number`}
              size={`sm`}
              value={addDiagnostic.room_number}
              onChange={handleAddChange}
            />
          </Col>
          <Col xs={3}>
            <p className="form-label align-left mb-1">
              PhilHealth Member <span className="red"> *</span>
            </p>
            <Radio.Group
              // onChange={handleAddChange}
              onChange={(e) => handleAddChange(e, "is_philhealth_member")}
              name="is_philhealth_member"
              value={patientDetails?.phic_membership_type === null ? "0" : "1"}
              disabled
            >
              <Radio value="1" className="me-2">
                Yes
              </Radio>
              <Radio value="0">No</Radio>
            </Radio.Group>
          </Col>
        </Row>
        <Row className="mt-2 px-1">
          <Col xs={3}>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Lab Type"
              value={filterConfig.parent_category_id || null}
              onChange={(value) => handleLabFilter(value)}
              options={labCategories}
              allowClear
            ></Select>
          </Col>
          <Col xs={3}>
            <Input.Search
              placeholder="Search Lab Test"
              size="medium"
              // onChange={(e) => setSearch(e.target.value)}
              onSearch={(e) => handleSearch(e)}
              onChange={(e) => handleEmptySearch(e)}
              allowClear
            />
          </Col>
          {/* <Col className="mt-1 ms-1">
            <Checkbox
              checked={addDiagnostic?.for_lab === "1"}
              onChange={(e) => handleAddChange(e, "for_lab")}
            >
              Queue Patient for Laboratory?
            </Checkbox>
          </Col> */}
        </Row>
        <Row>
          <>
            {loading ? (
              <div>
                <Spin indicator={customSpinner}>
                  <div style={{ minHeight: "200px" }}></div>
                </Spin>
              </div>
            ) : diagnosticTests ? (
              <>
                {(() => {
                  const mainKey = Object.keys(diagnosticTests || {})[0]
                  if (!mainKey) return null
                  const group = diagnosticTests[mainKey]
                  if (!group) return null
                  return Object.keys(group).map((subtype) => {
                    return group[subtype].map(
                        (test, index) => {
                          return (
                            <Col
                              key={index}
                              xs={4}
                              className="my-1 diagnostics-each-box"
                            >
                              <Checkbox
                                value={test.lab_name} // <-- use correct field
                                onChange={(e) =>
                                  handleSelect(
                                    e,
                                    false,
                                    mainKey,
                                    subtype,
                                    action
                                  )
                                }
                                disabled={test.is_existing === "1"}
                              >
                                {test.lab_name}
                              </Checkbox>
                            </Col>
                          )
                        }
                      )
                  })
                })()}
                {/* {diagnosticTests?.laboratory?.["clinical chemistry"]?.map(
                  (test, index) => {
                    return (
                      <Col
                        key={index}
                        xs={4}
                        className="my-1 diagnostics-each-box"
                      >
                        <Checkbox
                          value={test.name} // <-- use correct field
                          onChange={(e) =>
                            handleSelect(
                              e,
                              false,
                              "laboratory",
                              "clinical chemistry",
                              action
                            )
                          }
                          disabled={test.is_existing === "1"}
                        >
                          {test.lab_name}
                        </Checkbox>
                      </Col>
                    )
                  }
                )} */}

                {/* LABORATORY WITH SUBTYPE */}
                {/* {"laboratory" in diagnosticTests &&
                  Object.keys(diagnosticTests.laboratory).map(
                    (subtype, subIndex) => (
                      <Row className="my-3" key={`lab-subtype-${subIndex}`}>
                        <label className="font-bold mb-2 uppercase w-full">{`LABORATORY (${subtype})`}</label>
                        <Checkbox.Group
                          style={{ width: "100%" }}
                          value={Object.keys(selectedDiagnosticTests)}
                        >
                          <Row className="flex-wrap flex-grow-1">
                            {diagnosticTests.laboratory_with_subtype[
                              subtype
                            ].map((test, index) => {
                              // const isNew = selectedDiagnosticTests[`${test}_is_new`] !== "0";
                              return (
                                <Col
                                  key={index}
                                  xs={4}
                                  className="my-1 diagnostics-each-box"
                                >
                                  <Checkbox
                                    value={test}
                                    onChange={(e) =>
                                      handleSelect(
                                        e,
                                        false,
                                        "laboratory",
                                        subtype,
                                        action
                                      )
                                    }
                                    // disabled={!isNew}
                                    disabled={
                                      selectedDiagnosticTests[
                                        `${test}_is_existing`
                                      ] === "1"
                                    }
                                  >
                                    {test}
                                  </Checkbox>
                                </Col>
                              )
                            })}
                          </Row>
                        </Checkbox.Group>
                      </Row>
                    )
                  )} */}

                {/* LABORATORY */}
                {/* {"laboratory" in diagnosticTests &&
                  diagnosticTests["laboratory"].length > 0 && (
                    <Row className="my-3">
                      <label className="font-bold mb-2 uppercase w-full">
                        LABORATORY
                      </label>
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        value={Object.keys(selectedDiagnosticTests)}
                      >
                        <Row className="flex-wrap flex-grow-1">
                          {diagnosticTests.laboratory.map((test, index) => {
                            return (
                              <Col
                                key={index}
                                xs={4}
                                className="my-1 diagnostics-each-box"
                              >
                                <Checkbox
                                  value={test}
                                  onChange={(e) =>
                                    handleSelect(
                                      e,
                                      false,
                                      "laboratory",
                                      "",
                                      action
                                    )
                                  }
                                  // disabled={!isNew}
                                  disabled={
                                    selectedDiagnosticTests[
                                      `${test}_is_existing`
                                    ] === "1"
                                  }
                                >
                                  {test}
                                </Checkbox>
                              </Col>
                            )
                          })}
                        </Row>
                      </Checkbox.Group>
                    </Row>
                  )} */}

                {/* LABORATORY WITH SUBTYPE */}
                {/* {"radiology_with_subtype" in diagnosticTests &&
                  Object.keys(diagnosticTests.radiology_with_subtype).map(
                    (subtype, subIndex) => (
                      <Row className="my-3" key={`radio-subtype-${subIndex}`}>
                        <label className="font-bold mb-2 uppercase w-full">{`RADIOLOGY (${formatLabel(
                          subtype
                        )})`}</label>
                        <Checkbox.Group
                          style={{ width: "100%" }}
                          value={Object.keys(selectedDiagnosticTests)}
                        >
                          <Row className="flex-wrap flex-grow-1">
                            {diagnosticTests.radiology_with_subtype[
                              subtype
                            ].map((test, index) => {
                              // const isNew = selectedDiagnosticTests[`${test}_is_new`] !== "0";
                              return (
                                <Col
                                  key={index}
                                  xs={4}
                                  className="my-1 diagnostics-each-box"
                                >
                                  <Checkbox
                                    value={test}
                                    onChange={(e) =>
                                      handleSelect(
                                        e,
                                        false,
                                        "radiology",
                                        subtype,
                                        action
                                      )
                                    }
                                    // disabled={!isNew}
                                    disabled={
                                      selectedDiagnosticTests[
                                        `${test}_is_existing`
                                      ] === "1"
                                    }
                                  >
                                    {test}
                                  </Checkbox>
                                </Col>
                              )
                            })}
                          </Row>
                        </Checkbox.Group>
                      </Row>
                    )
                  )} */}

                {/* RADIOLOGY */}
                {/* {"radiology" in diagnosticTests &&
                  diagnosticTests["radiology"].length > 0 && (
                    <Row className="my-3">
                      <label className="font-bold mb-2 uppercase w-full">
                        RADIOLOGY
                      </label>
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        value={Object.keys(selectedDiagnosticTests)}
                      >
                        <Row className="flex-wrap flex-grow-1">
                          {diagnosticTests.radiology.map((test, index) => {
                            return (
                              <Col
                                key={index}
                                xs={4}
                                className="my-1 diagnostics-each-box"
                              >
                                <Checkbox
                                  value={test}
                                  onChange={(e) =>
                                    handleSelect(
                                      e,
                                      false,
                                      "radiology",
                                      "",
                                      action
                                    )
                                  }
                                  disabled={
                                    selectedDiagnosticTests[
                                      `${test}_is_existing`
                                    ] === "1"
                                  }
                                >
                                  {test}
                                </Checkbox>
                              </Col>
                            )
                          })}
                        </Row>
                      </Checkbox.Group>
                    </Row>
                  )} */}

                {/* SPECIAL TEST */}
                {/* {"special test" in diagnosticTests &&
                  diagnosticTests["special test"].length > 0 && (
                    <Row className="my-3">
                      <label className="font-bold mb-2 uppercase w-full">
                        SPECIAL TEST
                      </label>
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        value={Object.keys(selectedDiagnosticTests)}
                      >
                        <Row className="flex-wrap flex-grow-1">
                          {diagnosticTests["special test"].map(
                            (test, index) => {
                              // const isNew = selectedDiagnosticTests[`${test}_is_new`] !== "0";
                              return (
                                <Col
                                  key={index}
                                  xs={4}
                                  className="my-1 diagnostics-each-box"
                                >
                                  <Checkbox
                                    value={test}
                                    onChange={(e) =>
                                      handleSelect(
                                        e,
                                        false,
                                        "special test",
                                        "",
                                        action
                                      )
                                    }
                                    // disabled={!isNew}
                                    disabled={
                                      selectedDiagnosticTests[
                                        `${test}_is_existing`
                                      ] === "1"
                                    }
                                  >
                                    {test}
                                  </Checkbox>
                                </Col>
                              )
                            }
                          )}
                        </Row>
                      </Checkbox.Group>
                    </Row>
                  )} */}
              </>
            ) : (
              <div className="flex justify-center items-center my-4">
                No data available
              </div>
            )}
          </>

          <Row className="my-3">
            <label className="font-bold mb-2">FASTING (OPTIONAL)</label>
            <Radio.Group
              style={{ width: "100%" }}
              // onChange={handleAddChange}
              onChange={(e) => handleAddChange(e, "fasting")}
              value={addDiagnostic.fasting}
            >
              <Row className="flex-wrap flex-grow-1">
                {fastingOptions?.map((data, index) => {
                  return (
                    <Col
                      key={index}
                      xs={4}
                      className="my-1 diagnostics-each-box"
                    >
                      <Radio value={data.value}>{data.label}</Radio>
                    </Col>
                  )
                })}
              </Row>
            </Radio.Group>
          </Row>

          <Row className="mt-3">
            <TextArea
              id="notes"
              name="notes"
              formLabel={`NOTES`}
              size={`sm`}
              onChange={handleAddChange}
              value={addDiagnostic.notes}
            />
          </Row>
          <Row>
            <Col xs={6}>
              <TextField
                id="chief_complaint"
                name="chief_complaint"
                formLabel={`Chief Complaint`}
                size={`sm`}
                value={addDiagnostic.chief_complaint}
                onChange={handleAddChange}
                disabled
              />
            </Col>
            <Col xs={6}>
              <span>
                Attending Physician
                <label className="red"> *</label>
              </span>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Attending Physician"
                value={addDiagnostic.doctor_id}
                onChange={(value) => handleDoctorChange(value)}
                allowClear
                disabled={role !== "nurse"}
                options={doctorOptions}
                optionFilterProp="label"
                showSearch
              />
            </Col>
          </Row>
        </Row>

        <Row className="justify-content-end mt-2 mb-3">
          {addDiagnostic?.id ? (
            // <Col xs={2}>
            //   <BtnSave
            //     label={"Save changes"}
            //     size={"sm"}
            //     isClicked={isClicked}
            //     // disabled={
            //     //   Object.values(checkedDiagnostics || {}).every((value) => value === "") &&
            //     //   (!addDiagnostic?.diagnostic_date || addDiagnostic.diagnostic_date === null) &&
            //     //   Object.values(addDiagnostic || {}).every((value) => value === "")
            //     // }
            //     disabled={
            //       Object.values(checkedDiagnostics).every((value) => value === "") &&
            //       ( !addDiagnostic?.diagnostic_date ||
            //         addDiagnostic.diagnostic_date === null ||
            //         !addDiagnostic?.doctor_id ||
            //         addDiagnostic.doctor_id === null
            //       )
            //     }
            //     onClick={handleEdit}
            //   />
            // </Col>
            hasChanges() && ( // Only show if there are changes
              <Col xs={2}>
                <BtnSave
                  label={"Save changes"}
                  size={"sm"}
                  isClicked={isClicked}
                  disabled={
                    Object.values(checkedDiagnostics).every(
                      (value) => value === ""
                    ) &&
                    (!addDiagnostic?.diagnostic_date ||
                      addDiagnostic.diagnostic_date === null ||
                      !addDiagnostic?.doctor_id ||
                      addDiagnostic.doctor_id === null)
                  }
                  onClick={handleEdit}
                />
              </Col>
            )
          ) : (
            <Col xs={2}>
              <BtnSave
                label={"Submit"}
                size={"sm"}
                isClicked={isClicked}
                // disabled={
                //   Object.values(checkedDiagnostics).every((value) => value === "") &&
                //   Object.values(addDiagnostic).every((value) => value === "")
                // }
                disabled={
                  Object.values(checkedDiagnostics).every(
                    (value) => value === ""
                  ) ||
                  !addDiagnostic?.diagnostic_date ||
                  addDiagnostic.diagnostic_date === null ||
                  !addDiagnostic?.doctor_id ||
                  addDiagnostic.doctor_id === null
                }
                onClick={handleSubmit}
              />
            </Col>
          )}
        </Row>
      </div>
    </div>
  )
}

export default Diagnostics
